module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-06.a94fc17c.png";